import { __awaiter, __generator } from "tslib";
import axiosInstance from "../axiosInstance";
import endpoints from "../endpoints";
export var createTrip = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post("".concat(endpoints.api.createTrip), data)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var updateTrip = function (tripdId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.patch("".concat(endpoints.api.updateTrip, "/").concat(tripdId), data)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var uploadFile = function (formData) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post("".concat(endpoints.api.uploadFile), formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                })];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var inviteUsersToTrip = function (tripId, data) { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.post("".concat(endpoints.api.inviteUsersToTrip, "/").concat(tripId), data)];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data];
        }
    });
}); };
export var getTripCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get("".concat(endpoints.api.getTripCategories), {})];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data.result];
        }
    });
}); };
export var getBudgetCategories = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axiosInstance.get("".concat(endpoints.api.getBudgetCategories))];
            case 1:
                res = _a.sent();
                return [2 /*return*/, res.data.result];
        }
    });
}); };
